import { DefaultButton, PrimaryButton, TooltipHost } from "@fluentui/react";
import { useTranslation } from "react-i18next"
import "./UserColumn.css"
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";
import userContext from "../../context/users/UserContext";
import { useContext } from "react";
import { USERTYPES } from "../Constants";
import { getEnv } from "../../helpers/EnvHelper";
export const getAllFirmName = (list,keyIndex) => {
  let allFirmString = "";
  // console.log('--- Printing List ----',list);
  list?.map((item,index) => {
    if(index >= keyIndex){
      allFirmString += list[index].firmName;
      if (index < list.length - 1) {
        allFirmString += ", ";
      }
    }


  });
  return allFirmString;
}


export const SupervisorColumns = (userId, handleActionButton, handleUserClick, handleLockButton,openPasswordReset) => {

    const {t} = useTranslation();
    const childTrPadding = (getEnv("REACT_APP_HYBRID_MODE") == "false") ? "15px 0px 15px 10px" : "15px 10px";
    const rowTrPadding = "0px 10px";
    const{resetPasswordAllowed}=useContext(userContext);
    const {roles}=useContext(userContext);

    return [
      {
        id: "username",
        style: { width: "21%", boxSizing:'border-box',padding:rowTrPadding},
        headerStyle: {padding:childTrPadding, textAlign: "left", width: "21%", boxSizing:'border-box'},
        headerClass:"break-word",
        classChildName:
            "break-word cursor-pointer",
        header: () => (
          <span className="">Details</span>
        ),
        accessor: "clients",
        accessorKey: "clients",
        show: true,
        cell: (info) =>  <>
        <div>
            <div className="user-heading">{t("user.username")}</div>
            <div className="user-sub-heading">{info.row.original.username}</div>
        </div>

        <div className="user-mt-10">
            <div className="user-heading">Full Name</div>
            <div className="user-sub-heading">{info.row.original.firstName}{" "}{info.row.original.lastName}</div>
        </div>
      </>,
      },
      {
        id: "email",
        style: { width: "21%",padding:rowTrPadding,boxSizing:'border-box' },
        headerStyle: {padding:childTrPadding, textAlign: "left", width: "21%", boxSizing:'border-box'},
        headerClass:"break-word",
        classChildName:
            "break-word cursor-pointer",
        header: () => (
          <span className="">Contact Details</span>
        ),
        accessor: "email",
        accessorKey: "email",
        show: true,
        cell: (info) =>  <>
        <div>
            <div className="user-heading">{t("user.email")}</div>
            <div className="user-sub-heading">{info.row.original.email}</div>
        </div>

        <div className="user-mt-10">
            <div className="user-heading">{t("user.mobile")}</div>
            <div className="user-sub-heading">{info.row.original.mobile}</div>
        </div>

    </>,
      },
      {
        id: "firm-access",
        style: { width: "21%",boxSizing:'border-box',padding:rowTrPadding},
        headerStyle: {padding:childTrPadding, textAlign: "left", width: "21%", boxSizing:'border-box'},
        headerClass:"break-word",
        classChildName:
            "break-word cursor-pointer",
        header: () => (
          <span className="">Firm Access</span>
        ),
        accessor: "firmname",
        accessorKey: "firmname",
        show: true,
        cell: (info) =>  <>
        {info.row.original?.firmAccessList?.map((firm,index)=>{
          if(index < 3){
            return <div key={index} className="user-sub-heading">{firm.firmName} {`${info.row.original?.firmAccessList?.length - 1 == index? "":","}`}</div>
          }
          // if(index == 3 && info.row.original.firmAccessList.length == 4){
          //   return <div className="user-sub-heading">{firm.firmName}</div>
          // }

        })}
        {info.row.original?.firmAccessList?.length > 3 && <div >
            <CustomToolTipHost content={getAllFirmName(info.row.original?.firmAccessList,3)}>
            .....
            </CustomToolTipHost>
            </div>
          }
    </>,
      },
      {
        id: "action",
        style: { width:"37%", display:'flex', height:'80px', alignItems:'center', boxSizing:'border-box', padding:rowTrPadding, flexWrap:'nowrap' },
        headerStyle: {padding:childTrPadding, textAlign: "left", width: "37%", boxSizing:'border-box'},
        headerClass:"break-word",
        classChildName:
            "break-word cursor-pointer",
        header: () => (
          <span >{t("supervisor.action")}</span>
        ),
        accessor: "action",
        accessorKey: "action",
        show: true,
        cell: (cell) => <>
        {userId != cell.row.original.id && (

          <>
          {/* <p style={{margin:'0px'}}>{!cell.row.original.active ? "Inactive" : "Active"}</p> */}
          {!cell.row.original.active ?<PrimaryButton
            text={ "Activate"}
            //text={cell.row.values.action}
            onClick={(event) =>
              handleActionButton(event, cell.row.original.id, cell)
            }
            style={{
              width: "80px",
              padding: "0",
            }}
          />
          :
          <DefaultButton
          text={"Deactivate"}
          //text={cell.row.values.action}
          onClick={(event) =>
            handleActionButton(event, cell.row.original.id, cell)
          }
          style={{
            width: "80px",
            padding: "0",
          }}
        />
        }

          {!cell.row.original.accountNonLocked ?<PrimaryButton
            text={ "Unlock"}
            //text={cell.row.values.action}
            onClick={(event) =>
              handleLockButton(event, cell.row.original.id, cell)
            }
            style={{
              width: "80px",
              padding: "0",
              marginLeft: "10px"
            }}
          />
          :
          <DefaultButton
          text={"Lock"}
          //text={cell.row.values.action}
          onClick={(event) =>
            handleLockButton(event, cell.row.original.id, cell)
          }
          style={{
            width: "80px",
            padding: "0",
            marginLeft: "10px"
          }}
        />}
        {(resetPasswordAllowed || roles[0] === USERTYPES.ADMIN) && (
          <DefaultButton
            text="Reset Password"
            onClick={(event) =>openPasswordReset(event,`${cell.row.original.firstName || ""} ${cell.row.original.lastName || ""}`.trim(),cell.row.original.username)}
            styles={{ root: { minWidth: "120px",maxWidth: "100%", padding: 0, marginLeft: "10px" } }}
          />
        )}

        </>
        )}
      </>,
      },
    ];

    // return [
    //     {
    //       Header: "Details",
    //       accessor: "username",
    //       key: "username",
    //       className: "column-user-details-header",
    //       classChildName:
    //         "break-word cursor-pointer",
    //       headerStyle: {padding:"15px", textAlign: "left"},
    //       rowStyle: { padding: "15px",width:"15vw" },
    //       sorting: true,
    //       Cell: ({ cell }) => (
    //         <>
    //           <div>
    //               <div className="user-heading">{t("user.username")}</div>
    //               <div className="user-sub-heading">{cell.row.values.username}</div>
    //           </div>

    //           <div className="user-mt-10">
    //               <div className="user-heading">Full Name</div>
    //               <div className="user-sub-heading">{cell.row.original.firstName}{" "}{cell.row.original.lastName}</div>
    //           </div>
    //         </>
    //       ),
    //     },
    //     {
    //       Header: "Contact Details",
    //       accessor: "email",
    //       key: "email",
    //       className: "column-user-contact-header",
    //       classChildName: "break-word cursor-pointer",
    //       headerStyle: {padding: "15px", textAlign: "left"},
    //       rowStyle: { padding: "15px",width:"20vw" },
    //       sorting: false,
    //       Cell: ({ cell }) => (
    //         <>
    //             <div>
    //                 <div className="user-heading">{t("user.email")}</div>
    //                 <div className="user-sub-heading">{cell.row.original.email}</div>
    //             </div>

    //             <div className="user-mt-10">
    //                 <div className="user-heading">{t("user.mobile")}</div>
    //                 <div className="user-sub-heading">{cell.row.original.mobile}</div>
    //             </div>

    //         </>
    //       )
    //     },
    //     {
    //       Header: t("supervisor.action"),
    //       accessor: "action",
    //       key: "action",
    //       className: "column-user-action-header",
    //       classChildName: "break-word cursor-pointer",
    //       headerStyle: {padding: "15px", textAlign: "left"},
    //       rowStyle: {padding: "15px",width:"10vw" },
    //       sorting: false,
    //       Cell: ({ cell }) => (
    //         <>
    //           {userId != cell.row.original.id && (
    //             <>
    //             {/* <p style={{margin:'0px'}}>{!cell.row.original.active ? "Inactive" : "Active"}</p> */}
    //             {!cell.row.original.active ?<PrimaryButton
    //               text={ "Activate"}
    //               //text={cell.row.values.action}
    //               onClick={(event) =>
    //                 handleActionButton(event, cell.row.original.id, cell)
    //               }
    //               style={{
    //                 width: "80px",
    //                 padding: "0",
    //               }}
    //             />
    //             :
    //             <DefaultButton
    //             text={"Deactivate"}
    //             //text={cell.row.values.action}
    //             onClick={(event) =>
    //               handleActionButton(event, cell.row.original.id, cell)
    //             }
    //             style={{
    //               width: "80px",
    //               padding: "0",
    //             }}
    //           />}
    //           </>
    //           )}
    //         </>
    //       ),
    //     }
    //     ,
    //     {
    //       Header: "",
    //       accessor: "emtpy",
    //       key: "empty",
    //       className: "",
    //       classChildName:
    //         "break-word cursor-pointer no-color",
    //       headerStyle: {width:"55vw",borderBottom:'none',borderTop:'none',textAlign:'center'},
    //       rowStyle: { borderBottom:'none',pointerEvents:"none",backgroundColor:'none',width:"55vw" },
    //       sorting: true,
    //       Cell: ({ cell }) => (
    //         <>
    //         <div></div>
    //         </>
    //       ),
    //     },
    //   ]

}